import React from "react";
import PolicyPage from "./PolicyPage";
import { policyDocuments } from "../Datas/policyData";

function Accessibility() {
  return <PolicyPage document={policyDocuments.accessibility} />;
}

export default Accessibility;
